/* eslint-disable react-hooks/rules-of-hooks */
import axios from "axios";
import apiCustomClient from "./apiCustomClient";
const username='apiuser';
const password='Intellect@1234';
 
  // -----------------------------
  // Proxy-friendly fetch helper
  // -----------------------------
 

   
  const fetchAPICustomV1 = async (endpoint: string) => {
    //  console.log(endpoint);
    try {
      //  console.log(endpoint);
      const res = await axios.get(`/grodigital/${endpoint}`, {
        headers: {
          Authorization: 'Basic ' + btoa(username + ':' + password),
          // 'Content-Type': 'application/json',
          // 'Access-Control-Allow-Origin': '*',
          // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS' 
         
        },
      });
     //  console.log(res);
      return res.data;
    } catch (err: any) {
      console.error('Error fetching', endpoint, err);
      throw err;
    } 
  };

  export const fetchAPICustom = async (endpoint: string) => {
  try {

   
      const  res = await apiCustomClient.get(`${endpoint}`, {
        headers: {
          Authorization: 'Basic ' + btoa(username + ':' + password), 
        },
      });
      return res.data;
  } catch (err) {
    console.error("Error fetching", endpoint, err);
    throw err;
  }
};

export default fetchAPICustom;